import request from '@/plugins/request'




export const listCoupon = (pageSize,pageNum) => {
  return request({
    url: `/maintain/coupon/list/${pageSize}/${pageNum}`,
    method: 'POST',
  })
}
export const addCoupon = (data) => {
  return request({
    url: `/maintain/coupon/add`,
    method: 'POST',
    data
  })
}
export const updateCoupon = (data) => {
  return request({
    url: `/maintain/coupon/update`,
    method: 'POST',
    data
  })
}

export const refresh = () => {
  return request({
    url: `/maintain/coupon/refresh`,
    method: 'POST',
  })
}
